/**
 * Limites de negocio espelhados do backend, para a tela avisar antes de o
 * usuario gastar um clique numa acao que o servidor vai recusar.
 *
 * A regra de verdade continua no backend (`backend/src/filiais/limites.ts`):
 * aqui e so o aviso, nunca a validacao.
 */

/** Negocios (matriz + filiais) por empresa quando o plano nao define. */
export const LIMITE_PADRAO_FILIAIS = 5;

/** Limite efetivo a partir do `maxAccounts` do plano ("Maximo de negocios"). */
export function limiteDeFiliais(maxAccounts: number | null | undefined): number {
    return typeof maxAccounts === 'number' && Number.isInteger(maxAccounts) && maxAccounts >= 1
        ? maxAccounts
        : LIMITE_PADRAO_FILIAIS;
}
